import { Component } from '@angular/core';

@Component({
  selector: 'app-p-store',
  templateUrl: './p-store.component.html',
  styleUrls: ['./p-store.component.scss']
})
export class PStoreComponent {

}
